import React from 'react'
import StatusApplication from './StatusApplication'
import { checkPermission, permissionsConfig } from '../AdminPermission/PermissionChecker';

const DocumentPendingRenewApplications = () => {

  const editApplicationPermission = checkPermission(
    permissionsConfig.editRenewPendingApplications.role,
    permissionsConfig.editRenewPendingApplications.action,
    permissionsConfig.editRenewPendingApplications.type
  );
    
  const deleteApplicationPermission = checkPermission(
    permissionsConfig.deleteRenewPendingApplications.role,
    permissionsConfig.deleteRenewPendingApplications.action,
    permissionsConfig.deleteRenewPendingApplications.type
  );

  return (
    <StatusApplication appStatus="2" title="Document Pending" subTitle="Document Pending" application_type="1" pageFrom="renew/document-pending" editApplicationPermission={editApplicationPermission} deleteApplicationPermission={deleteApplicationPermission}></StatusApplication>
  )
}

export default DocumentPendingRenewApplications